document.addEventListener('DOMContentLoaded', () => {
  function updateDeliveryMessage() {
    // Get checkout button and message element
    const checkoutBtn = document.querySelector('[data-btn-checkout]');
    const messageEl = document.querySelector('.delivery-option-message');
    
    if (checkoutBtn && messageEl) {
      // Check if button is disabled
      if (checkoutBtn.disabled) {
        // Show the message
        messageEl.style.display = 'block';
      } else {
        // Hide the message
        messageEl.style.display = 'none';
      }
    }
  }

  // Style adjustments for the new layout
  function adjustCartLayout() {
    const cssCode = `
      .cart-shipping-options {
        margin-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #e8e8e8;
        padding-top: 15px;
      }
      
      .drawer__footer {
        z-index: 10;
        box-shadow: 0 -4px 6px -2px rgba(0, 0, 0, 0.05);
      }
      
      .drawer__scrollable {
        padding-bottom: 20px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
      
      .cart__checkout-wrapper {
        width: 100%;
      }
      
      .drawer__scrollable:after {
        content: '';
        display: block;
        height: 20px;
      }
    `;
    
    // Add styles to head
    const styleEl = document.createElement('style');
    styleEl.textContent = cssCode;
    document.head.appendChild(styleEl);
  }

  // Apply layout adjustments
  adjustCartLayout();

  // Run on initial load
  updateDeliveryMessage();

  // Check if csShippingApp is modifying the button
  document.addEventListener('cs:delivery:updated', () => {
    setTimeout(updateDeliveryMessage, 100);
  });

  // Also watch for any changes to the checkout button's disabled state
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        updateDeliveryMessage();
      }
    }
  });

  // Start observing the checkout button
  const checkoutBtn = document.querySelector('[data-btn-checkout]');
  if (checkoutBtn) {
    observer.observe(checkoutBtn, { attributes: true });
  }
}); 